/* Ranking locale: nessun servizio esterno, nessun modello addestrato. */
(function(root) {
  const norm = value => String(value || '').trim().toLowerCase();
  const tags = p => (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',')).map(norm).filter(t => t && !t.includes('__'));
  const generic = new Set(['casual','elegante','fashionista','fw26','fw25','ss26','accessori di abbigliamento']);
  function kind(p) {
    const text = norm(p.type) + ' ' + norm(p.title);
    const groups = [
      ['scarpe', /stival|scarpa|scarpe|sandalo|sandali|ballerin|mocassin|sneaker|beatles/],
      ['borse', /borsa|borse|bauletto|bustina|pochette|zaino|tracolla/],
      ['cinture', /cintura|cinture/], ['abiti', /abito|abiti|vestito|vestiti|tuta /],
      ['pantaloni', /pantalon|jeans|denim|bermuda|shorts/], ['gonne', /gonna|gonne/],
      ['capispalla', /cappott|giacca|giacche|blazer|piumin|parka|trench|blouson|bomber|ecopelliccia/],
      ['maglieria', /maglia|maglie|maglione|cardigan|felpa|dolcevita|lupetto|girocollo/],
      ['top', /blusa|camicia|camicie|top |tshirt|t-shirt|canotta/]
    ];
    return groups.find(([,pattern])=>pattern.test(text))?.[0] || norm(p.type);
  }
  const shared = (a, b) => tags(a).filter(t => !generic.has(t) && tags(b).includes(t)).length;
  function affinity(p, anchor) {
    if (!anchor) return 0;
    return (kind(p) && kind(p) === kind(anchor) ? 14 : 0)
      + Math.min(6, shared(p, anchor) * 2)
      + (norm(p.vendor) && norm(p.vendor) === norm(anchor.vendor) ? 2 : 0)
      + (anchor.price > 0 && p.price > 0 ? Math.max(0, 2 - Math.abs(Math.log(p.price / anchor.price)) * 2) : 0);
  }
  function select(products, {current, history = [], excluded = [], seen = [], limit = 8, variety = 0.3, random = Math.random, score = null} = {}) {
    const banned = new Set([String(current?.id), ...excluded.map(String)]), map = new Map();
    for (const p of products) {
      if (!p || !p.available || banned.has(String(p.id))) continue;
      const old = map.get(String(p.id));
      map.set(String(p.id), old ? {...old, ...p, native: old.native || p.native, contextual: old.contextual || p.contextual, complementary: old.complementary || p.complementary} : p);
    }
    const pool = [...map.values()].map(p => ({p,score: (score ? score(p) : affinity(p, current)) + (p.native ? 4 : 0) + (p.contextual ? 3 : 0)
      + Math.min(5, history.reduce((sum,h,i)=>sum + affinity(p,h) * (0.3 / (i + 1)),0))
      - (seen.map(String).includes(String(p.id)) ? 3 : 0)}));
    const selected = [];
    while (pool.length && selected.length < limit) {
      const ranked = pool.map((entry,i)=>({...entry,i,rank: entry.score - selected.filter(p=>norm(p.type) && norm(p.type)===norm(entry.p.type)).length * 1.5})).sort((a,b)=>b.rank-a.rank);
      // Campiona solo fra candidati vicini al migliore: evita casualità fuori tema.
      const band = ranked.filter(e=>e.rank >= ranked[0].rank - (2 + variety * 10)).slice(0, Math.max(2,Math.ceil(3 + variety * 12)));
      const pick = variety > 0 ? band[Math.min(band.length-1,Math.floor(random()*band.length))] : ranked[0];
      selected.push(pick.p); pool.splice(pick.i,1);
    }
    return selected;
  }
  function selectCart(products, {anchors = [], ...options} = {}) {
    const unique = [...new Map(anchors.map(p=>[String(p.id),p])).values()];
    if (!unique.length) return [];
    const present = new Set(unique.map(kind));
    const pairs = {
      capispalla: ['top','maglieria','pantaloni','gonne','scarpe','borse','cinture'],
      pantaloni: ['top','maglieria','capispalla','scarpe','borse','cinture'],
      gonne: ['top','maglieria','capispalla','scarpe','borse','cinture'],
      top: ['pantaloni','gonne','capispalla','scarpe','borse'],
      maglieria: ['pantaloni','gonne','capispalla','scarpe','borse'],
      abiti: ['capispalla','scarpe','borse','cinture'],
      scarpe: ['pantaloni','gonne','abiti','borse'],
      borse: ['scarpe','abiti','capispalla'], cinture: ['pantaloni','gonne','abiti']
    };
    return select(products, {...options, excluded: [...unique.map(p=>p.id), ...(options.excluded || [])], score: p=>{
      const category = kind(p);
      const affinities = unique.map(anchor=>affinity(p,anchor) - (category && category===kind(anchor) ? 14 : 0)
        + (pairs[kind(anchor)]?.includes(category) ? 5 : 0)
        + Math.min(2,tags(p).filter(t=>['casual','elegante','fashionista'].includes(t) && tags(anchor).includes(t)).length));
      return Math.max(...affinities) + affinities.reduce((a,b)=>a+b,0)/unique.length
        + (p.complementary ? 6 : 0) - (present.has(category) ? 5 : 0);
    }});
  }
  // Gli abbinamenti editoriali restano nell'ordine dei prodotti del carrello.
  function selectCartOutfit(groups, lowcost, {anchors=[], limit=40, ...options}={}) {
    const banned=new Set(anchors.map(p=>String(p.id))), selected=[];
    for(const group of groups) for(const p of group || []) {
      if(!p?.available || banned.has(String(p.id)))continue;
      selected.push(p);banned.add(String(p.id));
      if(selected.length>=limit)return selected;
    }
    const affordable=lowcost.filter(p=>p.available && Number(p.price)>0 && Number(p.price)<3000);
    return selected.concat(selectCart(affordable,{...options,anchors,excluded:[...banned],limit:limit-selected.length}));
  }
  const api = {select, selectCart, selectCartOutfit, affinity, kind};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.ExtroRecommendationRanking = api;
})(typeof window !== 'undefined' ? window : globalThis);
